import { Component, Input, OnInit } from '@angular/core';
import { WagtailCategoryItemInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'gea-shop-category-cms-tile',
    templateUrl: './cms-tile.component.html',
    styleUrls: ['./cms-tile.component.scss'],
    standalone: false
})

export class CmsTileComponent implements OnInit {

  @Input() cmsPage?: WagtailCategoryItemInterface

  gridWidth?: 1 | 2 | 3

  ngOnInit(): void {
    if(this.cmsPage) {
      this.gridWidth = this.cmsPage.shop_cat.value.column_width
    } else {
      this.gridWidth = 1
    }
  }

}
